<template>
  <div>
    <v-card class="mt-5 ma-2">
      <v-data-table
        dense
        :headers="headers"
        :items="itemCards"
        :search="search"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ itemCards.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.card_name`]="{ item }">
          <span class="caption">{{ item.card_name }}</span>
        </template>
        <template v-slot:[`item.createdon`]="{ item }">
          <span class="caption">{{
            convertTimeStampToDate(item.createdon).toUpperCase()
          }}</span>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span class="caption">{{ item.description }}</span>
        </template>
        <template v-slot:[`item.sub_card_type`]="{ item }">
          <!-- <span
              class="caption"
              v-if="
                item.card_details.sub_cardtype == undefined ||
                item.card_details.sub_cardtype === null
              "
              >-</span
            > -->
          <span class="caption" v-if="item.sub_card_type == 1"
            >Physical card</span
          >
          <span class="caption" v-if="item.sub_card_type == 2"
            >Virtual card</span
          >
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small @click="viewemp(item)" color="primary">mdi-eye</v-icon>

          <!-- <v-icon small @click="delitem(item)" color="red" class="ml-4"
          >mdi-delete</v-icon
        > -->

          <v-icon
            small
            color="red"
            @click="confirmdeleteItem(item)"
            class="ml-4"
            >mdi-delete</v-icon
          >
        </template>

        <template v-slot:top>
          <v-card elevation="4" class="mb-6">
            <v-layout row wrap class="mb-2">
              <v-row>
                <v-col cols="3">
                  <v-card-title class="primary--text ml-3">
                    Card Type Master
                  </v-card-title>
                </v-col>
                <v-spacer />

                <v-col lg="2" class="mt-4 mr-n8">
                  <v-dialog persistent v-model="createCard" width="600">
                    <template #activator="{ on: createCard }">
                      <v-btn
                        rounded
                        class="primary mt-1 ml-n5"
                        depressed
                        v-on="{ ...createCard }"
                        @click="addViewCard()"
                      >
                        <v-icon left dark>mdi-plus</v-icon>Add
                      </v-btn>
                    </template>
                    <v-card class="elevation-0">
                      <v-toolbar dark color="primary" class="elevation-0" dense>
                        <v-toolbar-title>{{ titilecard }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn class text @click="Close()">
                          <v-icon color="white">mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text class="mt-6">
                        <v-form ref="formCat" v-model="valid" lazy-validation>
                          <v-row layout>
                            <!-- :rules="[(v) => !!v || 'Select card type']" -->
                            <v-radio-group v-model="cardrow" v-if="hide" row>
                              <div
                                class="primary--text font-weight-medium text ml-4"
                              >
                                <b>Choose Card Type</b> :
                              </div>

                              <v-radio
                                label="Physical Card"
                                value="radio-1"
                                style="margin-left: 35px"
                                color="black"
                              ></v-radio>
                              <v-radio
                                label="Virtual Card"
                                value="radio-2"
                                style="margin-left: 25px"
                                color="black"
                              ></v-radio>
                            </v-radio-group>
                            <v-col cols="12" v-if="hide1">
                              <v-text-field
                                dense
                                class="mb-n5"
                                outlined
                                :readonly="checkreadonly"
                                v-model="sub_card_type"
                                label="Sub Card Type *"
                                maxlength="20"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                dense
                                outlined
                                :readonly="checkreadonly"
                                v-model="createName"
                                label="Card Type *"
                                @keydown.space="preventLeadingSpace"
                                maxlength="20"
                                :rules="[(v) => !!v || 'Required']"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="mt-n4">
                              <v-text-field
                                dense
                                outlined
                                :readonly="checkreadonly"
                                v-model="createDescription"
                                label="Type Description *"
                                @keydown.space="preventLeadingSpace"
                                maxlength="100"
                                :rules="[(v) => !!v || 'Required']"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                              lg="12"
                              sm="12"
                              xl="12"
                              xs="12"
                            >
                              <v-row style="margin-left: 1px">
                                <v-radio-group v-model="AllowAtm" row>
                                  <span
                                    class="black--text mt-n6 pa-1 SomeColor"
                                    style="font-size: 16px"
                                  >
                                    <b>ATM Transactions</b>
                                  </span>

                                  <v-radio
                                    value="radio-1"
                                    label="Yes"
                                    style="margin-left: 37px"
                                    color="black"
                                    class="mt-n6"
                                  ></v-radio>
                                  <v-radio
                                    value="radio-0"
                                    label="No"
                                    class="mt-n6"
                                    color="black"
                                    style="margin-left: 91px"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                              <v-row style="margin-left: 1px">
                                <v-radio-group v-model="Ecommerce" row>
                                  <span
                                    class="black--text mt-n6 pa-1 SomeColor"
                                    style="font-size: 16px"
                                  >
                                    <b>E-Commerce</b>
                                  </span>

                                  <v-radio
                                    value="radio-1"
                                    label="Yes"
                                    style="margin-left: 74px"
                                    color="black"
                                    class="mt-n6"
                                  ></v-radio>
                                  <v-radio
                                    value="radio-0"
                                    label="No"
                                    class="mt-n6"
                                    color="black"
                                    style="margin-left: 93px"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                              <v-row style="margin-left: 1px">
                                <v-radio-group v-model="Country" row>
                                  <span
                                    class="black--text mt-n6 pa-1 SomeColor"
                                    style="font-size: 16px"
                                  >
                                    <b>Country</b>
                                  </span>

                                  <v-radio
                                    value="radio-1"
                                    label="Only Malaysia"
                                    style="margin-left: 111px"
                                    color="black"
                                    class="mt-n6"
                                  ></v-radio>
                                  <v-radio
                                    value="radio-0"
                                    label="Malaysia + Overseas"
                                    class="mt-n6"
                                    color="black"
                                    style="margin-left: 20px"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                              <v-row style="margin-left: 1px">
                                <v-radio-group v-model="Merchants" row>
                                  <span
                                    class="black--text mt-n6 pa-1 SomeColor"
                                    style="font-size: 16px"
                                  >
                                    <b>Merchants</b>
                                  </span>

                                  <v-radio
                                    value="radio-1"
                                    label="All Merchants"
                                    style="margin-left: 91px"
                                    color="black"
                                    class="mt-n6"
                                  ></v-radio>
                                  <v-radio
                                    value="radio-0"
                                    label="Selected Merchants"
                                    class="mt-n6"
                                    color="black"
                                    style="margin-left: 20px"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-col>
                            <!-- <v-col cols="6" class="mt-n2">
                            <v-checkbox
                              v-model="checkbox3"
                              :readonly="checkreadonly"
                              label="Allow at all Merchants"
                              class="mt-n3"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="checkbox1"
                              :readonly="checkreadonly"
                              label="Allow ATM Transactions"
                              class="mt-n3"
                            ></v-checkbox>
                             <v-checkbox
                              v-model="checkbox9"
                              :readonly="checkreadonly"
                              label="Country - Only Malaysia"
                              class="mt-n3"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="checkbox4"
                              :readonly="checkreadonly"
                              label="Allow at selected Merchants"
                              class="mt-n3"
                            ></v-checkbox>
                            <v-card-subtitle
                              class="caption black--text ml-n4 mt-4 mb-n4"
                              v-if="
                                titilecard == 'View Card Type Master' &&
                                  checkbox4 == true
                              "
                              >List of Few MCC's :</v-card-subtitle
                            >

                         
                          </v-col> -->
                            <!-- <v-col cols="6" class="mt-n1">
                            <v-checkbox
                              v-model="checkbox5"
                              :readonly="checkreadonly"
                              label="Allow E-Commerce"
                              class="mt-n3"
                            ></v-checkbox>
                         
                            <v-checkbox
                              v-model="checkbox2"
                              :readonly="checkreadonly"
                              label="Allow Shopping with Pin"
                              class="mt-n3"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="checkbox6"
                              :readonly="checkreadonly"
                              label="Allow Contactless Shopping "
                              class="mt-n3"
                            ></v-checkbox>
                          </v-col> -->
                          </v-row>
                          <div v-if="titilecard == 'Create Card Type Master'">
                            <v-row
                              layout
                              class="pa-2 mt-2"
                              align="center"
                              justify="center"
                              v-if="Merchants == 'radio-0'"
                            >
                              <v-select
                                v-model="e7"
                                :items="mccitems"
                                :readonly="checkreadonly"
                                label="Select"
                                multiple
                                outlined
                                chips
                                persistent-hint
                              ></v-select>
                            </v-row>
                          </div>
                          <v-row
                            v-if="titilecard == 'View Card Type Master'"
                            class="mt-n2"
                          >
                            <span
                              v-for="(mcc, idx) in newmccitems"
                              :key="idx"
                              class="ml-2 mt-2"
                            >
                              <v-card outlined class="mr-2">
                                <li class="ml-5 mr-2 primary--text">
                                  {{ mcc }}
                                </li>
                              </v-card>
                            </span>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          rounded
                          width="90px"
                          v-if="checkreadonly == false"
                          color="primary"
                          dark
                          class="margin-bottom-0-dot-70em"
                          @click="Continue()"
                          >Create</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="confirmDeleteDialog1"
                    width="400"
                    persistent
                  >
                    <v-card class="overflow-hidden">
                      <v-toolbar class="elevation-0" dense>
                        <span> Are you sure you want to submit ? </span>
                        <v-spacer></v-spacer>
                        <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
                      </v-toolbar>
                      <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-row class="mt-2" style="margin-left: 200px">
                          <v-btn
                            text
                            width="90px"
                            class="mb-4 red--text"
                            @click="confirmDeleteDialog1 = false"
                            >Back</v-btn
                          >
                          <v-btn
                            text
                            width="90px"
                            class="mb-4 primary--text"
                            @click="deleteItem()"
                            >Submit</v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-row class="ml-10 mt-n10">
                  <v-col cols="3" class="ml-1">
                    <label class="caption">Corporate</label>
                    <v-select
                      v-model="corpId"
                      :items="corpList"
                      item-text="corp_name"
                      item-value="corp_id"
                      dense
                      solo
                      elevation-5
                      placeholder="Corporate"
                      class="mt-1"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" class="ml-1">
                    <!-- <label class="caption primary--text"><b>STATUS</b></label> -->
                    <label class="caption">Card Type</label>

                    <v-select
                      v-model="userStatusFilter"
                      dense
                      :items="statusItems"
                      item-text="statusName"
                      item-value="StatusId"
                      required
                      placeholder="Card Type"
                      class="mt-1"
                      solo
                      elevation-5
                    ></v-select>
                  </v-col>
                  <v-col cols="2" class="ml-1">
                    <v-btn
                      small
                      fab
                      color="primary"
                      @click="gctmasterapi"
                      class="elevation-0 mt-7"
                    >
                      <!-- cardfilter(corpId, userStatusFilter) -->
                      <!-- cardfilter(userStatusFilter) -->
                      <!-- userModuleAccess() -->
                      <v-icon>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="3" class="mt-7 ml-9">
                    <v-text-field
                      v-model="search"
                      dense
                      class="ml-n8"
                      color="primary"
                      append-icon="mdi-magnify"
                      label="Search"
                      auto-grow
                      solo
                      elevation-5
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-row>
            </v-layout>
          </v-card>
        </template>
      </v-data-table>
      <OverleyProccessg :overlay="overlay" />
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    search: "",
    valid: "",
    titilecard: "",
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    hide: false,
    hide1: false,
    cardrow: "",
    AllowAtm: "",
    Merchants: "",
    Country: "",
    Ecommerce: "",
    disable: false,
    checkreadonly: false,
    // checkbox4: false,
    // checkbox6: false,
    // checkbox7: false,
    // checkbox5: true,
    // checkbox9: false,
    createCard: false,
    overlay: false,
    itemCards: [],

    corpId: 0,
    mccitems: [],
    cardmaster_id: "",
    e7: [],
    confirmDeleteDialog1: false,
    statusItems: [
      {
        statusName: "All",
        StatusId: 0,
      },
      {
        statusName: "Physical Card",
        StatusId: 1,
      },
      {
        statusName: "Virtual Card",
        StatusId: 2,
      },
    ],
    headers: [
      {
        text: "SL NO",
        align: "left",
        sortable: false,
        value: "sl_no",
      },
      {
        text: "CARD TYPE",
        value: "card_name",
        sortable: false,
      },
      {
        text: "TYPE DESCRIPTION",
        value: "description",
        sortable: false,
      },
      {
        text: "CARD TYPE",
        value: "sub_card_type",
        sortable: false,
      },
      {
        text: "CREATED ON",
        value: "createdon",
        sortable: false,
      },

      {
        text: "VIEW",
        value: "actions",
        sortable: false,
      },
    ],
    createDescription: "",
    createName: "",
    itemCardsNew: [],
    userStatusFilter: 0,
    corpList: [],
  }),
  // watch: {
  //   checkbox3(val) {
  //     // this.itemCards = this.itemCardsNew.filter(
  //     //   (card) => card.sub_card_type == val
  //     // );
  //     // console.log("vvv", val);
  //     // this.checkbox4==true?this.checkbox3=false:this.checkbox3=true
  //     if (this.checkbox3 == true) {
  //       this.checkbox4 = false;
  //     }

  //     // this.checkbox3 = this.checkbox4==true ?  false : true
  //   },
  //   checkbox4(val) {
  //     if (this.checkbox4 == true) {
  //       this.checkbox3 = false;
  //     }
  //   },
  //   // itemCardsNew
  // },
  mounted() {
    this.getCatDetails();
  },
  created() {
    this.userModuleAccess();
    this.getCropName();
  },
  methods: {
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    async getCropName() {
      var inputData = {
        method_name: "ADMINCARDS",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        status: "",
        method_param: {
          action: "GETCOP",
          search_text: "",
          corp_id: "0",
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.corpList = responseData.data.data;
        // console.log("corpList", this.corpList);
        this.corpList.unshift({
          corp_id: 0,
          corp_name: "All",
        });
      }
      // this.corpList.push({
      //   corp_id: 0,
      //   corp_name: "All",
      // });
    },
    // cardfilter(name, val) {
    //   // console.log("name", name);
    //   // console.log("val", val);

    //   if (val != "0" && name != "All") {
    //     this.itemCards = this.itemCardsNew.filter(
    //       (card) => card.sub_card_type == val && card.corp_name == name
    //     );
    //   } else if (val == "0" && name == "All") {
    //     this.itemCards = this.itemCardsNew;
    //   } else if (val != "0" && name == "All") {
    //     this.itemCards = this.itemCardsNew.filter(
    //       (card) => card.sub_card_type == val
    //     );
    //   } else if (val == "0" && name != "All") {
    //     this.itemCards = this.itemCardsNew.filter(
    //       (card) => card.corp_name == name
    //     );
    //   }
    // },
    Continue() {
      if (this.$refs.formCat.validate()) {
        this.createCardtypemaster();
      }
    },
    Close() {
      // this.$refs.formCat.reset();
      // this.$refs.formCat.resetValidation();
      this.createCard = false;
    },
    convertTimeStampToDate(date) {
      // console.log(date);
      let day = date.split(" ")[0].split("-")[0];
      let month = date.split(" ")[0].split("-")[1];
      let year = date.split(" ")[0].split("-")[2];
      let hrs = date.split(" ")[1].split(":")[0];
      let mins = date.split(" ")[1].split(":")[1];
      // console.log("day", day);
      // console.log("month", month);
      // console.log("year", year);

      let new_date = new Date(year, month - 1, day, hrs, mins, 0).getTime();
      // console.log(new_date);
      let a = new Date(new_date).toLocaleDateString("en-in", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      return a;
    },
    async createCardtypemaster() {
      //console.log(this.e7);`

      var catIds = [];
      //var self = this;
      this.e7.forEach(function (ele) {
        catIds.push({
          value: ele,
        });
      });
      // end

      //to get matched objects from the list mccitems according to selected ids
      let matchedIdObj = this.mccitems.filter((o1) =>
        catIds.some((o2) => o1.value === o2.value)
      );
      //end

      //to fetch array of codes of the selected category
      var catCodeArray = [];
      matchedIdObj.forEach(function (obj) {
        catCodeArray.push(obj.code);
      });
      //end
      if (this.$refs.formCat.validate()) {
        var inputData = {
          method_name: "ADMINSET",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "APORTAL",
          method_param: {
            action: "CRDMASTER",
            cat_code: catCodeArray,
            card_name: this.createName,
            has_atm:
              this.AllowAtm == "radio-1"
                ? 1
                : this.AllowAtm == "radio-0"
                ? 0
                : 0,
            has_mcc: this.Merchants == "radio-1" ? 1 : 0,
            has_few_mcc: this.Merchants == "radio-0" ? 0 : 0,
            // has_without_pin: this.checkbox6 == true ? 1 : 0,
            has_ecommerce_3ds:
              this.Ecommerce == "radio-1"
                ? 1
                : this.Ecommerce == "radio-0"
                ? 0
                : 0,
            // has_ecommerce_non_3ds: this.checkbox7 == true ? 1 : 0,
            only_malaysia:
              this.Country == "radio-1" ? 1 : this.Country == "radio-0" ? 0 : 0,
            is_master: "1",
            card_description: this.createDescription,
            corp_id: this.corpId,
            group_id: this.checkbox3 == 1 ? [] : this.e7,
            sub_card_type: this.cardrow == "radio-2" ? 2 : 1,
            // mcc_values: this.e7,
            // search_text: "",
            // corp_id: 0,
          },
        };
        var responseData1 = await apiCall(inputData);
        // console.log("responseData CRDMASTER ", responseData);

        if (responseData1.data.status == "00") {
          this.$refs.formCat.resetValidation();
          // this.$refs.formCat1.reset();
          this.createCard = false;

          this.$store.commit("snackbar/showMessage", {
            content: "Created successfully",
            color: "green",
          });
          this.gctmasterapi();
          // (this.createName = ""),
          //   (this.createDescription = ""),
          //   (this.checkbox1 = false),
          //   (this.checkbox2 = false),
          //   (this.checkbox5 = false),
          //   (this.checkbox4 = false),
          //   (this.checkbox6 = false),
          //   (this.checkbox7 = false),
          //   (this.checkbox8 = false),
          //   (this.checkbox9 = false),

          //   (this.e7 = []);
          // console.log("e7", this.e7);
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: "Card type already exist",
            color: "red",
          });
        }
      }
    },
    async deleteItem() {
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "DELCT",
          cardmaster_id: this.cardmaster_id,
          isEnc: 0,
        },
      };
      // console.log("cardmaster_id", this.cardmaster_id);
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.confirmDeleteDialog1 = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Deleted successfully",
          color: "green",
        });
        this.gctmasterapi();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.confirmDeleteDialog1 = false;
      }
    },
    async userModuleAccess() {
      this.overlay = true;
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "CUSTVIEW",
          search_text: this.search,
          corp_id: this.corpId,
        },
      };

      var responseData = await apiCall(inputData);
      this.overlay = false;

      this.customertableData =
        responseData.data.data == null ? [] : responseData.data.data;
      this.customertableData.forEach(function (ele) {
        ele.departBal = "-";
        ele.cardBal = "-";
        ele.corporateName = "-";
      });
    },
    async gctmasterapi() {
      this.overlay = true;
      // console.log(this.corpId, "this.corpId");
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "GCTMASTER",
          corp_id: this.corpId == "All" ? 0 : this.corpId,
          search_text: "",
          sub_card_type: this.userStatusFilter,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.itemCardsNew = responseData.data.data;
          this.itemCards = responseData.data.data;
          // console.log("itemCards", this.itemCards);
          this.cardmaster_id = this.itemCards.cardmaster_id;
        }
        // console.log("cardmaster_id get ", this.cardmaster_id);
        this.overlay = false;
      } else {
        this.overlay = false;
      }
    },
    async getCatDetails() {
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "GETCATGRP",
          search_text: "",
          // corp_id: this.corpId == "All" ? 0 : this.corpId,
          // sub_card_type: this.sub_card_type,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(responseData,"responseData")
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var self = this;
          responseData.data.data.forEach(function (ele) {
            self.mccitems.push({
              text: ele.group_name,
              value: ele.group_id,
              code: ele.group_id,
            });
          });

          // console.log("mccitems1", self.mccitems.group_id);
          this.gctmasterapi();
        }
      } else {
        this.itemsCategary = [];
      }
    },
    addViewCard() {
      this.titilecard = "Create Card Type Master";
      this.createName = "";
      this.cardrow = "";
      this.Merchants = "";
      this.AllowAtm = "";
      this.Ecommerce = "";
      this.Country = "";
      this.hide = true;
      this.hide1 = false;
      this.e7 = [];
      this.createDescription = "";
      this.checkreadonly = false;
      // this.checkbox1 = false;
      // this.checkbox2 = false;
      // this.checkbox3 = false;
      // this.checkbox4 = false;
      // this.checkbox5 = false;
      // this.checkbox6 = false;
      // this.checkbox9 = false;
      // this.checkbox7 = false;
      // this.$refs.formCat.reset();
    },
    viewemp(items) {
      // console.log(items.group_details[0].group_id,"this.catCodeArray")
      this.titilecard = "View Card Type Master";
      this.createCard = true;
      this.createName = items.card_name;
      this.hide1 = true;
      this.hide = false;

      // this.cardrow = this.cardrow == "radio-1" ? 1 : 2;
      this.sub_card_type =
        items.sub_card_type == "1" ? "Physical Card Type" : "Virtual Card Type";
      this.createDescription = items.description;
      // (this.checkbox1 = items.has_atm == 1 ? true : false),
      //   (this.checkbox2 = items.has_pos == 1 ? true : false),
      //   (this.checkbox6 = items.has_without_pin == 1 ? true : false),
      //   (this.checkbox3 = items.has_mcc == 1 ? true : false),
      //   (this.checkbox4 = items.has_few_mcc == 1 ? true : false),
      //   (this.checkbox5 = items.has_ecommerce_3ds == 1 ? true : false),
      //   (this.checkbox7 = items.has_ecommerce_non_3ds == 1 ? true : false);
      // this.checkbox9 = items.only_malaysia == 1 ? true : false;
      this.Merchants =
        items.has_mcc == "1"
          ? "radio-1"
          : items.has_few_mcc == "0"
          ? "radio-0"
          : "0";
      //  this.Merchants = items.has_few_mcc == "0" ? "radio-0" : "radio-0";
      this.Ecommerce =
        items.has_ecommerce_3ds == "1"
          ? "radio-1"
          : items.has_ecommerce_3ds == "0"
          ? "radio-0"
          : "0";
      this.AllowAtm =
        items.has_atm == "1"
          ? "radio-1"
          : items.has_atm == "0"
          ? "radio-0"
          : "0";
      this.Country =
        items.only_malaysia == "1"
          ? "radio-1"
          : items.only_malaysia == "0"
          ? "radio-0"
          : "0";
      this.checkreadonly = true;
      this.disable = true;

      var newmcc = [];

      if (items.group_details != null) {
        for (let i = 0; i < items.group_details.length; i++) {
          newmcc.push(items.group_details[i]);
        }
      }

      this.newmccitems = [];
      for (let i = 0; i < newmcc.length; i++) {
        this.newmccitems.push(newmcc[i].group_name);
      }
      this.e7 = this.newmccitems;
    },

    confirmdeleteItem(item) {
      // console.log("item", item);
      this.cardmaster_id = item.cardmaster_id;
      this.itemForDelete = item;
      // this.indexOfItemToDelete = this.fileList.indexOf(item);
      // this.fileList.splice(this.indexOfItemToDelete, 1);
      // console.log("indexOfItemToDelete", this.indexOfItemToDelete);
      this.confirmDeleteDialog1 = true;
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
.SomeColor {
  background: #f5f5f5;
}
</style>
